import * as R from 'ramda'

import { BROWSER } from './utils'

export type Configuration = {
  assets: string[]
  servers: string[]
  proxy: string
  menuOptions: string
}

const DEFAULT_KARATFPS_CONFIG: Configuration = {
  assets: ['https://server.karatfps.lol/assets/0/.index.source?v=20260901noconsolecfg'],
  servers: ['server.karatfps.lol/ws/'],
  proxy: 'server.karatfps.lol/service/proxy/',
  menuOptions: 'guibutton "play ffa arena" [js "Module.cluster.connect(\'\', \'\')"]',
}

export let CONFIG: Configuration = DEFAULT_KARATFPS_CONFIG

const REPLACED = {
  ORIGIN: '#origin',
  HOST: '#host',
  PROTOCOL: '#protocol',
}

function fillHost(url: string): string {
  return url
    .replace(REPLACED.ORIGIN, window.location.origin)
    .replace(REPLACED.HOST, window.location.host)
    .replace(REPLACED.PROTOCOL, window.location.protocol)
}

function fillAssetHost(url: string): string {
  const newHost = fillHost(url)

  // Don't cache asset sources pointing to this host
  if (url.includes(REPLACED.HOST) || url.includes(REPLACED.ORIGIN)) {
    return `!${newHost}`
  }

  return newHost
}

function getInjected(): Maybe<Configuration> {
  try {
    const injected = INJECTED_FRAGFI_CONFIG
    // This will never run if INJECTED_FRAGFI_CONFIG is not defined
    return injected
  } catch (e) {
    return null
  }
}

function init() {
  const config = getInjected()
  if (config != null) {
    CONFIG = config
  } else {
    const configStr = process.env.FRAGFI_CONFIG
    if (configStr == null) {
      CONFIG = DEFAULT_KARATFPS_CONFIG
      return
    }

    CONFIG = JSON.parse(configStr)
  }

  CONFIG.assets = R.chain((v): string[] => {
    if (v.startsWith('mobile:')) {
      return BROWSER.isMobile ? [fillAssetHost(v.slice(7))] : []
    }
    if (v.startsWith('desktop:')) {
      return !BROWSER.isMobile ? [fillAssetHost(v.slice(8))] : []
    }
    return [fillAssetHost(v)]
  }, CONFIG.assets)
  CONFIG.servers = R.map((v) => fillHost(v), CONFIG.servers)
  CONFIG.proxy = fillHost(CONFIG.proxy)
}

init()
